import React from 'react';
import {
  Alert,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
} from '@mui/material';
import ApprovalStepEditor from '../../attendancemng/ApprovalStepEditor';

const OrderApprovalV2Form = ({
  approvalLines = [],
  approvalLineLoading = false,
  lineId,
  approvalSteps,
  onApprovalLineChange,
  onApprovalStepsChange,
  currentUserUuid,
  approvalStepsError,
  finalApprovalAvailable = false,
  finalApprovalYn = false,
  finalApprovalComment = '',
  onFinalApprovalYnChange,
  onFinalApprovalCommentChange,
}) => {
  return (
    <Grid container spacing={2}>
      {finalApprovalAvailable && (
        <Grid item xs={12}>
          <Alert
            severity="warning"
            action={
              <FormControlLabel
                control={
                  <Switch
                    checked={finalApprovalYn}
                    onChange={(event) => onFinalApprovalYnChange(event.target.checked)}
                  />
                }
                label="전결 승인"
              />
            }
          >
            전결 승인으로 저장하면 작성 즉시 최종 승인 처리되고 대표/관리 책임자에게 보고 알림이 발송됩니다.
          </Alert>
        </Grid>
      )}
      {finalApprovalYn && (
        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="전결 사유"
            value={finalApprovalComment}
            onChange={(event) => onFinalApprovalCommentChange(event.target.value)}
            placeholder="전결 처리 사유를 입력하세요."
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <TextField
          select
          fullWidth
          size="small"
          label="v2 결재선 템플릿"
          value={lineId}
          onChange={(event) => onApprovalLineChange(event.target.value)}
          disabled={finalApprovalYn || approvalLineLoading || approvalLines.length === 0}
          helperText={
            finalApprovalYn
              ? '전결 승인 시 일반 결재선은 사용하지 않습니다.'
              : approvalLineLoading
                ? 'v2 결재선 불러오는 중'
                : approvalLines.length === 0
                  ? '저장된 템플릿이 없습니다. 아래에서 직접 단계를 구성하세요.'
                  : '템플릿을 선택하면 결재 단계가 자동 반영됩니다. 이후 직접 수정하면 템플릿 선택은 해제됩니다.'
          }
        >
          <MenuItem value="">직접 선택</MenuItem>
          {approvalLines.map((line) => (
            <MenuItem key={line.lineId} value={line.lineId}>
              {line.lineNm}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        {!finalApprovalYn && (
          <ApprovalStepEditor
            steps={approvalSteps}
            onChange={onApprovalStepsChange}
            currentUserUuid={currentUserUuid}
          />
        )}
        {approvalStepsError && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {approvalStepsError}
          </Alert>
        )}
      </Grid>
    </Grid>
  );
};

export default OrderApprovalV2Form;
